import { channelQuery, TvChannel } from '@funtech-int/kp-graphql-sdk/yango-movies-www';
import { createResourceQuery } from '@funtech-int/rival';
import { useResources, useSignal } from '@funtech-int/rival-react';

import { GraphqlClient } from '@/shared/lib/graphqlClient';
import { useGraphqlClient } from '@/shared/hooks/useGraphqlClient';
import { useProfileManager } from '@/shared/hooks/useProfileManager';

interface ChannelVariables {
    contentId: string;
    billingFeaturesCount: number;
}

interface GQLQueryParams {
    client: GraphqlClient;
    variables: ChannelVariables;
}

const CHANNEL_UPDATE_DELAY = 60 * 60 * 1000;

const channelResourceQuery = createResourceQuery<GQLQueryParams, TvChannel | undefined | null>({
    key(ctx) {
        return [channelQuery.name, JSON.stringify(ctx.variables)].join(':');
    },
    fetch(ctx) {
        return ctx.client
            .fetch({
                operation: channelQuery,
                variables: {
                    contentId: ctx.variables.contentId,
                },
            })
            .then(({ data }) => data);
    },
    toJSON(data) {
        return data as any;
    },
    hydrate(data: any) {
        return channelQuery.hydrate(data) as any;
    },
});

interface ChannelQueryParams {
    contentId: string;
}

export function useChannel(params: ChannelQueryParams) {
    const client = useGraphqlClient();
    const billingFeaturesCount = useSignal(useProfileManager().billingFeatureNames).length;

    const [channel] = useResources(
        channelResourceQuery(
            {
                client,
                variables: {
                    contentId: params.contentId,
                    billingFeaturesCount,
                },
            },
            { lifetime: CHANNEL_UPDATE_DELAY }
        )
    );

    return { channel };
}
